import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import apiClient from '../api/axios';

const ConsentModal = ({ show, onClose, onConsentGiven, userId }) => {
    const [consent, setConsent] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const handleSaveConsent = async () => {
        if (!consent) {
            setError('Необходимо согласие на обработку персональных данных для продолжения.');
            return;
        }

        setSaving(true);
        setError('');

        try {
            await apiClient.put('/users/me', { consent_to_data_processing: consent });
            onConsentGiven();
        } catch (err) {
            setError('Не удалось сохранить согласие. Пожалуйста, попробуйте снова.');
            console.error('Error saving consent:', err);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal show={show} centered backdrop="static" keyboard={false}>
            <Modal.Header closeButton={false}>
                <Modal.Title>Требуется ваше согласие</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-3">
                    Для продолжения использования сервиса EventPlan необходимо ваше согласие на обработку персональных данных.
                </p>
                <div className="form-check mb-3">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="consentModal"
                        checked={consent}
                        onChange={(e) => {
                            setConsent(e.target.checked);
                            setError('');
                        }}
                    />
                    <label htmlFor="consentModal" className="form-check-label" style={{ fontSize: '0.9rem' }}>
                        Я ознакомлен(а) с <Link to="/privacy" target="_blank">Политикой обработки персональных данных</Link>. 
                        Я согласен(на) на обработку моего адреса электронной почты (обязательно) и имени (указывается по желанию, может быть изменено) 
                        для целей регистрации и использования сервиса EventPlan. Согласие может быть отозвано в любое время.
                    </label>
                </div>
                {error && <div className="alert alert-danger small">{error}</div>}
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    variant="primary" 
                    onClick={handleSaveConsent}
                    disabled={!consent || saving}
                >
                    {saving ? 'Сохранение...' : 'Продолжить'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConsentModal;
